import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            market: '',
            currency: ''
        };
    };

    componentWillMount() {
        this._updateDate();
    }

    componentDidMount(){
        this.setState({
            lang: this.props.lang,
            market: this.props.market,
            branding: this.props.branding,
            branding_primary: this.props.branding_primary,
            currency: this.props.currency
        })
    }

    componentWillReceiveProps(nextProps, nextState){
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market,
            currency: nextProps.currency
        })
    }

    _updateDate(){
        let date = new Date();
        let year = date.getFullYear();
        this.setState({year: year});
    }

    _renderText(item) {
        return langRegister.get("footer", item, this.state.lang);
    }

    renderSaleschannelName(){
        try {
            if(window.location.hostname.indexOf("propertybooster") !== -1){
                return 'propertybooster'
            }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                return 'boostabostad'
            }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                return 'yieldlock'
            }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
                //yieldspotter don't have a saleschannel yet
                return 'yieldlock'
            }else{
                return 'propertybooster'
            }
        }catch (e) {
            return 'propertybooster'
        }
    }

    renderTermsName(){
        try {
            if(window.location.hostname.indexOf("propertybooster") !== -1){
                return 'Property Booster'
            }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                return 'Boosta Bostad'
            }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                return 'YIELDLOCK'
            }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
                return 'YIELDSPOTTER'
            }else{
                return 'Property Booster'
            }
        }catch (e) {
            return 'Property Booster'
        }
    }

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad(){
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        }catch (e) {
            return false
        }
    }

    renderYieldlock(){
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        }catch (e) {
            return false
        }
    }

    renderYieldspotter(){
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        }catch (e) {
            return false
        }
    }

    render() {
        return (
            <div style={this.renderYieldlock() || this.renderYieldspotter()?{background: '#00273A'}:{}} className={Styles.container}>
                <div style={(this.state.branding && this.state.branding_primary) ? {borderBottom: "calc(var(--size-factor) * 2px) solid" + this.state.branding_primary, borderRight: "calc(var(--size-factor) * 2px) solid" + this.state.branding_primary} : {}} className={
                    cx(Styles.desktopBorder,
                        {
                            [Styles.desktopBorderPropertyBooster]: this.renderPropertyBooster() && !this.state.branding,
                            [Styles.desktopBorderBoostaBostad]: this.renderBoostaBostad() && !this.state.branding,
                            [Styles.desktopBorderYieldlock]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.state.branding,
                        })
                }/>
                <div className={Styles.containerInner}>
                    <div className={Styles.containerInnerContent}>
                        <div style={this.renderYieldlock() || this.renderYieldspotter()?{color: '#80929C'}:(this.state.branding && this.state.branding_primary && window.innerWidth < 1050) ? {borderTop: "calc(var(--size-factor) * 2px) solid" + this.state.branding_primary} : {}} className={cx(Styles.containerInnerContentText,
                            {
                                [Styles.containerInnerContentTextPB]: this.renderPropertyBooster(),
                                [Styles.containerInnerContentTextBB]: this.renderBoostaBostad(),
                                [Styles.containerInnerContentTextYL]: this.renderYieldlock(),
                                [Styles.containerInnerContentTextYS]: this.renderYieldspotter(),
                            })
                        }>
                            <a style={this.renderYieldlock() || this.renderYieldspotter()?{color: '#80929C'}:{}} className={Styles.containerInnerContentTextLink} target={"_blank"} href={'https://legal.' + dataRegister.domain + "/" + this.state.market + "/" + this.state.lang +"/" + "terms" + "/" + this.renderSaleschannelName()}>{this._renderText("item_19")}</a>{" "}|{" "}
                            <a style={this.renderYieldlock() || this.renderYieldspotter()?{color: '#80929C'}:{}} className={Styles.containerInnerContentTextLink} target={"_blank"} href={'https://legal.' + dataRegister.domain + "/" + this.state.market + "/" + this.state.lang +"/" + "privacy" + "/" + this.renderSaleschannelName()}>{this._renderText("item_20")}</a>{" "}|{" "}
                            <a style={this.renderYieldlock() || this.renderYieldspotter()?{color: '#80929C'}:{}} className={Styles.containerInnerContentTextLink} target={"_blank"} href={'https://legal.' + dataRegister.domain + "/" + this.state.market + "/" + this.state.lang +"/" + "acceptance" + "/" + this.renderSaleschannelName()}>{this._renderText("item_21")}</a>{" "}|{" "}©{" "}{this.state.year}{" "}{this.renderTermsName()}
                        </div>
                    </div>
                    <div className={Styles.containerInnerLogo}>
                        {
                            !this.renderYieldspotter() && this.state.branding &&
                            <a href={"https://" + dataRegister.domain + "/" + this.state.market + "/" + this.state.lang + "?search=true&currency=" + this.state.currency} target={'_blank'}>
                                <img className={Styles.containerInnerLogoDesktop} src={salesChannelRegister.get('logo_dashboard')}/>
                            </a>
                        }
                        {
                            !this.renderYieldspotter() && !this.state.branding &&
                            <a href={"/" + this.state.market + "/" + this.state.lang}>
                                <img className={Styles.containerInnerLogoDesktop} src={salesChannelRegister.get('logo_dashboard')}/>
                            </a>
                        }
                        {
                            this.renderYieldspotter() &&
                            <a href={"/" + this.state.market + "/" + this.state.lang}>
                                <img className={Styles.containerInnerLogoDesktop} src={require("../../assets/images/YS_logo_white_dash.png")}/>
                            </a>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/component.js